/**
 * @author Tanmay <tanmay.pawar@314ecorp.com>
 * @description secure app
 */

import React, { ComponentType, useState } from 'react';
import log from 'loglevel';

import SplashPortal from './SplashPortal';
import config from 'configs/index';
import storageEngine from 'store/storageEngine';
import { KeycloakProvider, KeycloakClient } from 'components/react-keycloak';

const LazyApp = React.lazy(() => import('./App'));
const LazyLoginPage = React.lazy(() => import('components/app/LoginPage'));

const client = new KeycloakClient({
	keycloak: config.keycloak.config,
	initOptions: config.keycloak.initOptions,
});

const SecureApp: React.FC = () => {
	const [status, setStatus] = useState('Signing in ...');
	log.info(status);

	const changeStatus = (message: string) => {
		setStatus(message);
		log.info(`[BOOTSTRAP] ${message}`);
	};

	const handleAuthSuccess = () => {
		changeStatus('Signed in');
		storageEngine.clear();
	};

	const handleAuthError = () => {
		changeStatus('Failed to Sign in. Please refresh and try again');
	};

	return (
		<>
			<KeycloakProvider
				client={client}
				loginPage={<LazyLoginPage />}
				onSuccess={handleAuthSuccess}
				onError={handleAuthError}
			>
				<React.Suspense fallback={<h1>Taking longer than expected</h1>}>
					<LazyApp onStatusChange={changeStatus} />
				</React.Suspense>
			</KeycloakProvider>
			<SplashPortal status={status} />
		</>
	);
};

export default SecureApp as ComponentType<unknown>;
